@if (!isComponentImported) {
  @if(error) {
    <div class="alert alert-danger">{{ error }}</div>
  }
  @if(banner) {
    <div class="alert alert-info" role="alert">{{ banner }}</div>
  }
  <div>
    <div class="span9">
      <h1 data-automation-name="venIndex">Vens</h1>
    </div>
    <p class="lead">
      VENs are the 'client' in the VEN-VTN client-server relationship. VENs can
      receive OADR events from a VTN or distribute OADR reports to a VTN. VENs
      determine which events to accept (opt into) based on the groups, resources,
      parties, and market contexts mapped to the VEN.
    </p>
  </div>
  @if(isAdmin) {
    <div style="margin-bottom: 10px">
      <div class="span3" style="text-align: right">
        <a
          id="createVEN"
          class="btn btn-large btn-primary"
          (click)="nextPage($event, '/createVen', router)"
          style="margin-top: 9px"
        >
          Create VEN</a>
      </div>
    </div>
  }
}
@if(isLoading) {
  <app-loader
    message="Loading VENs...">
  </app-loader>
} @else {
  <table class="table table-striped" >
    <thead>
    <tr>
      <th>ID</th>
      <th>Ven ID</th>
      <th>Ven name</th>
      <th>Profile</th>
      <th>Mode</th>
      <th>VTN (format: [vtn_id] : [id])</th>
      @if (!isComponentImported) {
        <th>Registered</th>
        <th>Platform</th>
        <th>Report enabled</th>
        <th>Send report cancellation</th>
        <th>Groups</th>
        <th>Resources (format: [resource_id] : [program_unit])</th>
        <th>Parties</th>
        <th>Market contexts</th>
        <th>Market contexts label</th>
        <th>Metadata reports</th>
      }
      <th>Paused</th>
      @if (!isComponentImported) {
        <th>Last Modified By</th>
        <th>Actions</th>
      }
    </tr>

    <!-- Search filter row -->
    <tr>
      <th><input placeholder="ID" class="input-sm form-control" type="search" [(ngModel)]="idSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="VEN ID" class="input-sm form-control" type="search" [(ngModel)]="venIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="VEN Name" class="input-sm form-control" type="search" [(ngModel)]="venNameSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Profile" class="input-sm form-control" type="search" [(ngModel)]="profileSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Mode" class="input-sm form-control" type="search" [(ngModel)]="modeSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="vtn_id" class="input-sm form-control" type="search" [(ngModel)]="vtnIdSearch" (input)="triggerSearch()"/></th>

      @if (!isComponentImported) {
        <th></th>
        <th><input placeholder="Platform" class="input-sm form-control" type="search" [(ngModel)]="platformSearch" (input)="triggerSearch()"/></th>
        <th>
          <select class="input-sm form-control" [(ngModel)]="reportEnabledSearch" (change)="triggerSearch()">
            <option value="">All</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </th>
        <th>
          <select class="input-sm form-control" [(ngModel)]="sendReportCancellationSearch" (change)="triggerSearch()">
            <option value="">All</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </th>

        <!-- NEW: Nested relationship search fields -->
        <th>
          <input
            placeholder="Group ID"
            class="input-sm form-control"
            type="search"
            [(ngModel)]="groupsSearch"
            (input)="triggerSearch()"
            title="Search by Group ID (e.g., 'production' or 'test-*')"
          />
        </th>
        <th>
          <input
            placeholder="resource_id"
            class="input-sm form-control"
            type="search"
            [(ngModel)]="resourcesSearch"
            (input)="triggerSearch()"
            title="Search by Resource ID"
          />
        </th>
        <th>
          <input
            placeholder="Party ID"
            class="input-sm form-control"
            type="search"
            [(ngModel)]="partiesSearch"
            (input)="triggerSearch()"
            title="Search by Party ID"
          />
        </th>
        <th>
          <input
            placeholder="Market Context"
            class="input-sm form-control"
            type="search"
            [(ngModel)]="marketContextsSearch"
            (input)="triggerSearch()"
            title="Search by Market Context"
          />
        </th>
        <th>
          <input
            placeholder="MC Label"
            class="input-sm form-control"
            type="search"
            [(ngModel)]="marketContextLabelSearch"
            (input)="triggerSearch()"
            title="Search by Market Context Label"
          />
        </th>
        <th>
          <input
            placeholder="Report ID"
            class="input-sm form-control"
            type="search"
            [(ngModel)]="metadataReportsSearch"
            (input)="triggerSearch()"
            title="Search by Metadata Report Specifier ID"
          />
        </th>
      }
      <th>
        <select class="input-sm form-control" [(ngModel)]="pausedSearch" (change)="triggerSearch()">
          <option value="">All</option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </th>
      @if (!isComponentImported) {
        <th></th>
        <th></th>
      }
    </tr>
    </thead>
    <tbody>
      @for(ven of displayedVens | paginate: paginationModel; track ven) {
        <tr>
          <td>{{ ven.id }}</td>
          <td>{{ ven.ven_id }}</td>
          <td>{{ ven.name }}</td>
          <td>{{ ven.profile }}</td>
          <td>
            <span class="badge badge-primary">
              {{ ven.mode | titlecase }}
            </span>
          </td>
          <td>{{ !!ven.vtn ? ven.vtn.vtn_id + " : " + ven.vtn.id : "" }}</td>
          @if (!isComponentImported) {
            <td>{{ ven.registration ? "Yes" : "No" }}</td>
            <td>
              {{
                !ven.platform_id ||
                (ven.environment === "Legacy" &&
                  (!ven.platform?.amqp_user ||
                    !ven.platform?.amqp_pass ||
                    !ven.platform?.amqp_host ||
                    !ven.platform?.exchange ||
                    !ven.platform?.routing_key))
                  ? "Undispatchable"
                  : ven.platform_id
              }}
            </td>
            <td>{{ ven.report_enabled }}</td>
            <td>{{ ven.send_report_cancellation_enabled }}</td>
            <td>
              @if(ven.groups && Array.isArray(ven.groups)) {
                @for(group of ven.groups; track group) {
                  <div>{{ group.group_id }}</div>
                }
              }
            </td>
            <td>
              @if(ven.resources && Array.isArray(ven.resources)) {
                @for(resource of ven.resources; track resource) {
                  <div>{{ resource.resource_id }} : {{ resource.program_unit }}</div>
                }
              }
            </td>
            <td>
              @if(ven.parties && Array.isArray(ven.parties)) {
                @for(party of ven.parties; track party) {
                  <div>{{ party.part_id }}</div>
                }
              }
            </td>
            <td>
              @if(ven.market_contexts && Array.isArray(ven.market_contexts)) {
                @for(market_context of ven.market_contexts; track market_context) {
                  <div>{{ market_context.market_context }}</div>
                }
              }
            </td>
            <td>
              @if(ven.market_contexts && Array.isArray(ven.market_contexts)) {
                @for(market_context of ven.market_contexts; track market_context) {
                  <div>{{ market_context.label }}</div>
                }
              }
            </td>
            <td>
              @if(ven.metadata_reports && Array.isArray(ven.metadata_reports)) {
                @for(metadata_report of ven.metadata_reports; track metadata_report) {
                  <div>{{ metadata_report.report_specifier_id }}({{ metadata_report.label }})</div>
                }
              }
            </td>
          }
          <td>{{ ven.paused }}</td>
          @if (!isComponentImported) {
            <td id="updated_by">{{ ven.updated_by }}</td>
            @if(isAdmin) {
              <td>
                <div class="btn-group">
                  <a
                    class="btn btn-default"
                    (click)="nextPage(ven.id, '/editVen', router)"
                    id="edit"
                    name="editVen"
                  >Edit</a
                  >
                  <a
                    class="btn btn-default"
                    (click)="nextPage(ven.id, '/editPollHistory', router)"
                    name="pollHistory"
                  >Event Poll History</a
                  >

                  <span>
            @switch(ven.paused) { @case(true){
              <button class="btn btn-warning" type="button" (click)="pause(ven, false)">
              Unpause
            </button>
            } @case(false) {
              <button class="btn btn-info" type="button" (click)="pause(ven, true)">
              Pause
            </button>
            } }
          </span>
                  @if(ven.secondary_vtn) {
                    <span>
             <button class="btn btn-warning" type="button" (click)="toggle_vtn(ven)">{{ven.on_primary? 'Switch to secondary':'Switch to primary'}}</button>
            </span>
                  }
                  <button id="delete" class="btn btn-danger" type="button" (click)="delete(ven)">
                    Delete
                  </button>
                </div>
              </td>
            }
          }
        </tr>
      }
      @if(displayedVens.length === 0) {
        <tr>
          <td [attr.colspan]="colspan" style="text-align: center">No Vens.</td>
        </tr>
      }
    </tbody>
    <tfoot>
    <tr>
      <td class="text-center" [attr.colspan]="colspan">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}
